import { emptyClient } from '@scts/test';
import { Party } from '@scts/models';
import { Tabs, Tab } from 'react-bootstrap';
import Appointee from './appointee';
import Client from './client';
import Representative from './representative';

export interface PartiesProps {
  parties: Party[];
}

// •	We will always get an appellant
// •	If we receive client details then the appellant Is actually an appointee
// •	If we receive no client details then the appellant is actually the client
// •	Multiple appellants (appointees) will have the same client details to act on behalf of...
// •	Reps are just Reps
// Appellant, Appellant Representative and/or Client

const Parties = (partiesProps: PartiesProps) => {
  partiesProps.parties.sort((a, b) => (a.type > b.type ? 1 : -1));

  const theClient = partiesProps.parties.find(
    (party) => party.type.toLowerCase() === 'client'
  );

  return (
    <>
      <div className="parties-wrapper">
        <Tabs>
          {partiesProps.parties.map(
            (party, index) =>
              party.type !== 'Client' && (
                <Tab
                  eventKey={index}
                  title={
                    party.type === 'Appellant Representative'
                      ? 'Representative'
                      : party.type
                  }
                  key={index}
                >
                  {/* only show the client if there is no client! As it will be the appellant/client */}
                  {party.type === 'Appellant' && !theClient && (
                    <Client client={party} />
                  )}

                  {/* if there is a client and an appellant we have an appointee acting on behalf of the client */}
                  {party.type === 'Appellant' && theClient && (
                    <Appointee
                      appointee={party}
                      client={theClient ? theClient : emptyClient}
                    />
                  )}

                  {/* rep is straightforward */}
                  {party.type === 'Appellant Representative' && (
                    <Representative rep={party} />
                  )}
                </Tab>
              )
          )}
        </Tabs>
      </div>{' '}
    </>
  );
};

export default Parties;
